import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=e6071870&scoped=true&"
import script from "./Rank.vue?vue&type=script&lang=js&"
export * from "./Rank.vue?vue&type=script&lang=js&"
import style0 from "./Rank.vue?vue&type=style&index=0&id=e6071870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6071870",
  null
  
)

export default component.exports